import { clsx } from 'clsx'

import InformationIcon from '@/ui-cvi/components/dxp-icons/system/InformationIcon'
import StatusWarningIcon from '@/ui-cvi/components/dxp-icons/system/StatusWarningIcon'

interface Props {
  actionText?: string
  bodyText: string
  closeText?: string
  onAction?: () => void
  onClose?: () => void
  title?: string
  type: 'info' | 'warning'
}

const Banner: React.FC<Props> = ({ actionText, bodyText, closeText, onAction, onClose, title, type }: Props) => {
  return (
    <div
      className={clsx(
        'p-semantic-global-md mt-semantic-global-md md:mt-semantic-global-lg gap-semantic-global-md flex w-full flex-col',
        type === 'info' && 'bg-semantic-global-info-lighter',
        type === 'warning' && 'border-semantic-global-warning-light bg-semantic-global-warning-lightest border'
      )}
      data-e2e-banner-type={type}
    >
      <div className="gap-semantic-global-md flex">
        <div className="pl-semantic-global-sm -mt-0.5">
          {type === 'info' ? <InformationIcon className="text-semantic-global-text-default size-8" size="xl" /> : null}
          {type === 'warning' ? (
            <StatusWarningIcon className="text-component-inline-notification-icon-color-warning size-8" size="lg" />
          ) : null}
        </div>
        <div className="gap-semantic-global-md flex flex-col">
          {title ? <h4 className="typography-heading-sm text-semantic-global-text-default">{title}</h4> : null}
          <p className="typography-body-md-regular">{bodyText}</p>
        </div>
      </div>
      {onClose || onAction ? (
        <div className="gap-semantic-global-md flex justify-end">
          {onClose ? (
            <button className="button-light-secondary-md" onClick={onClose} type="button">
              {closeText}
            </button>
          ) : null}
          {type === 'warning' && onAction && actionText ? (
            <button className="button-light-primary-md" onClick={onAction} type="button">
              {actionText}
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default Banner
